import { Badge, Nav } from 'react-bootstrap'
import { Icons } from '../../../../common/Icons.jsx'
import PropTypes from 'prop-types'

const FILTER_CONFIG = {
    wszystkie: {
        label: 'Wszystkie',
        icon: <Icons.checkList/>,
        tooltip: 'Wszystkie projekty',
    },
    aktywne: {
        label: 'Aktywne',
        icon: <Icons.project/>,
        tooltip: 'Projekty aktywne',
    },
    prosby: {
        label: 'Prośby',
        icon: <Icons.unlock/>,
        tooltip: 'Projekty oczekujące na decyzję (odblokowanie/anulowanie/wznowienie)',
    },
    archiwum: {
        label: 'Archiwum',
        icon: <Icons.archive/>,
        tooltip: 'Archiwum',
    },

}

export const ListFilterTabs = ({ 
    activeTab, 
    onTabChange, 
    counts = {}, 
}) => {
    const tabs = Object.entries(FILTER_CONFIG)

    return (
        <Nav variant="tabs" className="mb-3">
            {tabs.map(([key, config]) => (
                <Nav.Item key={key}>
                    <Nav.Link
                        active={activeTab === key}
                        onClick={() => onTabChange(key)}
                        className="d-flex align-items-center gap-2 text-dark"
                        title={config.tooltip}
                        style={{ cursor: 'pointer' }}
                    >
                        {config.icon}
                        <span className={activeTab === key ? 'fw-semibold' : ''}>
                            {config.label}
                        </span>
                        {counts[key] !== undefined && (
                            <Badge bg="dark">
                                {counts[key]}
                            </Badge>
                        )}
                    </Nav.Link>
                </Nav.Item>
            ))}
        </Nav>
    )
}

ListFilterTabs.propTypes = {
    activeTab: PropTypes.oneOf(['aktywne', 'prosby', 'archiwum', 'wszystkie']).isRequired,
    onTabChange: PropTypes.func.isRequired,
    counts: PropTypes.shape({
        aktywne: PropTypes.number,
        prosby: PropTypes.number,
        archiwum: PropTypes.number,
        wszystkie: PropTypes.number,
    }),
}

export default ListFilterTabs
